import Loadable from '../../components/loadable';

const ArchivedMemberships = Loadable({
  loader: () => import('../../pages/reports/archived_memberships/archived_memberships'),
});

angular.module('gym').value('ArchivedMemberships', ArchivedMemberships);

const ArchivedMembershipsFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/archived_memberships/archived_memberships_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('ArchivedMembershipsFiltersModal', ArchivedMembershipsFiltersModal);
